import HttpApi from '@/utils/HttpApi'

export default class PartnersApi {
    public static async viewPartners(params: any) {
        return await HttpApi.get<ApiPartnerList>('partners', params)
    }

    public static async getPartner(id: number) {
        return await HttpApi.get<ApiPartnerForm>(`partners/${id}`, null)
    }

    public static async createPartner(data: PartnerEntity) {
        return await HttpApi.post<ApiPartnerForm>('partners', data)
    }

    public static async updatePartner(data: PartnerEntity) {
        return await HttpApi.put<ApiPartnerForm>('partners', data)
    }
}
